import React, { Component } from 'react';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import history from './history';
import Cookies from 'universal-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faEnvelope, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import Logo from './assets/Logo_EPS_300.png';

const cookies = new Cookies();

const LoginForm = ({loginSubmit, messageStatut}) => {
  let email;
  let password;

  return (
    <div className="login-page">
      <div className="login-orb login-orb--top" aria-hidden="true" />
      <div className="login-orb login-orb--bottom" aria-hidden="true" />

      <main className="login-shell">
        <section className="login-intro" aria-label="Présentation d'Accès EPS">
          <div className="login-brand" aria-label="Accès EPS">
            <img src={Logo} className="login-brand-logo" alt="Accès EPS" />
          </div>

          <p className="login-copyright">© 2024 Accès EPS — Tous droits réservés</p>
        </section>

        <section className="login-card" aria-labelledby="login-title">
          <div className="login-card-heading">
            <span className="login-user-icon" aria-hidden="true"><FontAwesomeIcon icon={faUser} /></span>
            <h1 id="login-title">Connexion</h1>
            <p>Connectez-vous à votre compte</p>
          </div>

          <form className="login-form" onSubmit={(e) => {
            e.preventDefault();
            loginSubmit(email.value, password.value);
          }}>
            <label className="login-field">
              <span>E-mail</span>
              <span className="login-input-wrap">
                <span className="login-input-icon" aria-hidden="true"><FontAwesomeIcon icon={faEnvelope} /></span>
                <input type="email" autoComplete="email" placeholder="votre@email.com" ref={loginValue => {
                  email = loginValue;
                }} required />
              </span>
            </label>
            <label className="login-field">
              <span>Mot de passe</span>
              <span className="login-input-wrap">
                <span className="login-input-icon" aria-hidden="true"><FontAwesomeIcon icon={faLock} /></span>
                <input type="password" autoComplete="current-password" placeholder="Votre mot de passe" ref={passwordValue => {
                  password = passwordValue;
                }} required />
              </span>
            </label>

            <div className="login-form-options">
              <label className="login-remember"><input type="checkbox" defaultChecked /> <span>Se souvenir de moi</span></label>
              <button type="button" className="login-link">Mot de passe oublié ?</button>
            </div>

            {messageStatut && messageStatut !== 'Success' && messageStatut !== 'Loading' && (
              <p className="login-error" role="alert">E-mail ou mot de passe incorrect.</p>
            )}

            <button type="submit" className="login-submit">Se connecter <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" /></button>

            <div className="login-divider">ou</div>

            <button type="button" className="login-microsoft">
              <span className="microsoft-mark" aria-hidden="true"><i /><i /><i /><i /></span>
              <span>Se connecter avec Microsoft</span>
            </button>
          </form>

          <div className="login-card-footer">
            <span>Vous n'avez pas de compte ?</span>
            <button type="button" className="login-link">Contactez votre administrateur</button>
          </div>
        </section>
      </main>
    </div>
  );
};

class LoginClass extends Component {
  state = {messageStatut: null};

  loginSubmit(email,password) {
    const formData = new FormData();

    formData.append('email', email)
    formData.append('password', password)

    this.setState({messageStatut: 'Loading'});
    axios.post('/api/login', formData)
    .then((res) => {
      if(res.data.data && res.data.data[0] !== undefined && res.data.data[0].email)
      {
	console.log(res.data)
        if(res.data.session.authenticated === true)
        {
          cookies.set('authenticated', 'true', { path: '/', maxAge: '3600' });
          cookies.set('statut', res.data.data[0].statut, { maxAge: '3600' });
          history.push('/dashboard');
          history.go('/dashboard');
          this.setState({messageStatut: 'Success'});
        }
        else
        {
          this.setState({messageStatut: 'Doesn\'t exist'});
        }
      }
      else
      {
        this.setState({messageStatut: 'Doesn\'t exist'});
      }
    })
    .catch(() => this.setState({messageStatut: 'Doesn\'t exist'}));
  }

  render() {
    return (
      <LoginForm loginSubmit={this.loginSubmit.bind(this)} messageStatut={this.state.messageStatut}/>
    );
  }
}

export default LoginClass;
